import { getTokenVariable } from '../cookies';

export function checkIfSignedInAndOnline() {
    const isOnline = navigator.onLine;
    const isAuthenticated = !!getTokenVariable();

    return isOnline && isAuthenticated;
}
